function popupCall() {
    let popupCallEls = document.querySelectorAll('.jsPopupCall'),
        popupCloseEls = document.querySelectorAll('.jsPopupClose');
    if (popupCallEls) {
        popupCallEls.forEach(popupCallEl => {
            popupCallEl.addEventListener('click', function(e) {
                e.preventDefault();
                let popupEl = document.getElementById(popupCallEl.dataset.popup);
                if (popupEl) {
                    popupEl.classList.add('show');
                    popupEl.addEventListener('click', function name(e) {
                        if (e.target.id == popupCallEl.dataset.popup) {
                            popupEl.classList.remove('show');
                        }
                    });
                }
            });
        });
    }

    if (popupCloseEls.length > 0) {
        popupCloseEls.forEach(popupCloseEl => {
            popupCloseEl.addEventListener('click', function() {
                popupCloseEl.closest('.jsPopup').classList.remove('show');
            });
        });
    }
}

window.addEventListener('load', function() {
    popupCall();
});